export default "__VITE_ASSET__Bc$EfAZU__"